module.exports = __webpack_public_path__ + "img/bracken.77d0f0a5.png";